module.exports = __webpack_public_path__ + "static/media/surecom.96f8a7b3.png";